import React, { Suspense, lazy, useState } from 'react';
import './datumPassRequired.css';
import { Trans, useTranslation } from 'react-i18next';

// DatumPassOfferModal pulls in Pixi.js (ModalBackground) — load it only when the player asks for it
const DatumPassOfferModal = lazy(() => import('../../datumPass/components/DatumPassOfferModal'));

/** Server WS error code for a GRAM stake without an active DatumPass (PvpService.ERR_PASS_REQUIRED). */
export const PASS_REQUIRED_CODE = 'DATUM_PASS_REQUIRED';

/**
 * PvP games (Arena, Durak): GRAM stakes are DatumPass-only, free games are open to everyone.
 * Explains the rule and offers to buy the pass or to keep playing for free.
 */
export default function DatumPassRequiredModal({ onClose, onPlayFree, onPurchased }) {
  const { t } = useTranslation();
  const [offer, setOffer] = useState(false);

  if (offer) {
    return (
      <Suspense fallback={null}>
        <DatumPassOfferModal onClose={onClose} onPurchased={onPurchased} />
      </Suspense>
    );
  }

  return (
    <div className="dpr-overlay" onClick={onClose} role="presentation">
      <div className="dpr-card" role="dialog" aria-modal="true" aria-labelledby="dpr-title" onClick={(e) => e.stopPropagation()}>
        <div className="dpr-crown" aria-hidden="true">👑</div>
        <h3 id="dpr-title" className="dpr-title">{t('arena.pass_required_aria', 'DatumPass required')}</h3>
        <p className="dpr-text">
          <Trans
            i18nKey="pass_required.text"
            defaults="Playing for <b>GRAM</b> is available only with an active <b>DatumPass</b>. Free games are open to everyone."
            components={{ b: <b /> }}
          />
        </p>
        <div className="dpr-buttons">
          <button type="button" className="app-btn app-btn--green" onClick={() => setOffer(true)}>{t('partnership.get_pass', 'Get DatumPass')}</button>
          <button type="button" className="app-btn app-btn--purple" onClick={onPlayFree || onClose}>{t('pass_required.play_free', 'Play for free')}</button>
        </div>
      </div>
    </div>
  );
}
